import get from 'lodash/get';
import { C as CreateCartSession, M as MergeCarts } from '../MergeCarts-wo9UjKo5.js';
import { P as ProcessReactivateCart } from '../ProcessReactivateCart-fk5bSKoR.js';
import { c as privateMutate } from '../requestsCollection-_VRM28HJ.js';
import { isBackorderAllowed, isProductInStock } from './product.js';
import { formatPrice } from './price.js';
import { getCookie, setCookie, removeCookie } from './cookies.js';
import { g as COOKIE_CART_SESSION_ID, h as COOKIE_REACTIVATE_CART_SESSION_ID, r as COOKIE_ACCOR_GTM_CART_TRACKING } from '../cookies-l-jEMp6P.js';
import '../currency-_kacFJHO.js';
import '../language-BHHwgtQp.js';
import { C as CART_INVALID_ERROR_MESSAGES } from '../cart-Vtx0Wqgk.js';
import '../payment-YC9H491Y.js';
import { d as ERROR_CART_ID_NOT_FOUND, b as ERROR_CART_NOT_ACTIVE } from '../serverErrors-_VHsjhgw.js';
import { a as ProductType } from '../product-_pRduMz7.js';
import { extractErrorMessage } from './error.js';
import '../graphqlRequestClient-3KYHZKVm.js';
import 'react';
import 'graphql-request';
import 'lodash/cloneDeep';
import '../services/auth/index.js';
import './logToSlack.js';
import './currency.js';
import '../context/index.js';
import 'next/server';
import '../index-Oip0gjfj.js';
import 'next/router';
import '../helpers-kA_hdoOI.js';
import 'cookies-next';
import 'lodash';
import './fetchPolicyLookup.js';
import '../paths-ZKN3m62_.js';
import 'number-currency-format';
import './isBot.js';
import './logger.js';
import './logToRelic.js';

const getCartSessionId = (ctx) => String(getCookie(COOKIE_CART_SESSION_ID, ctx) || '');
const getReactivateCartSessionId = (ctx) => String(getCookie(COOKIE_REACTIVATE_CART_SESSION_ID, ctx) || '');
const setCartSessionId = (cartSessionId, options, ctx) => {
    // TODO: Update for MAREU
    // const hasFunctionalConsent = consent?.functional;
    // const options = hasFunctionalConsent ? { ...ctx, expires: oneMonthFromNow } : { ...ctx };
    setCookie(COOKIE_CART_SESSION_ID, cartSessionId, { ...ctx, ...options });
};
const deleteCartSessionId = (ctx) => {
    removeCookie(COOKIE_CART_SESSION_ID, ctx);
};
const deleteCartGtmData = (ctx) => {
    removeCookie(COOKIE_ACCOR_GTM_CART_TRACKING, ctx);
};
const createCartSession = async (apolloConfig, ctx) => {
    const cartSessionId = await privateMutate(apolloConfig(), {
        mutation: CreateCartSession,
    }, ctx).then(res => res.data.createEmptyCart);
    return cartSessionId;
};
const reactivateCart = async (reactivateCartSessionId, apolloConfig, ctx) => {
    try {
        const cartSessionId = await privateMutate(apolloConfig(), {
            mutation: ProcessReactivateCart,
            variables: {
                cartId: reactivateCartSessionId,
            },
        }, ctx).then(res => { var _a, _b, _c; return (_c = (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.processReactiveCart) === null || _b === void 0 ? void 0 : _b.cart) === null || _c === void 0 ? void 0 : _c.id; });
        if (cartSessionId) {
            setCartSessionId(cartSessionId, ctx);
            removeCookie(COOKIE_REACTIVATE_CART_SESSION_ID, ctx);
        }
        if (!cartSessionId) {
            console.info('Unable to reactivate previous cart. Keeping the current one.');
            removeCookie(COOKIE_REACTIVATE_CART_SESSION_ID, ctx);
            return {
                success: false,
                isCartIdNotFound: true,
            };
        }
        return {
            success: true,
            isCartIdNotFound: false,
        };
    }
    catch (e) {
        const errMsg = extractErrorMessage(e);
        const isCartIdNotFound = errMsg === null || errMsg === void 0 ? void 0 : errMsg.includes(ERROR_CART_ID_NOT_FOUND);
        const isCartNotActive = errMsg === null || errMsg === void 0 ? void 0 : errMsg.includes(ERROR_CART_NOT_ACTIVE);
        // Remove reactivate cart cookie in case of invalid cart states
        if (isCartIdNotFound || isCartNotActive) {
            removeCookie(COOKIE_REACTIVATE_CART_SESSION_ID, ctx);
            // If the current cart is not active, create a new one
            if (isCartNotActive) {
                const currentCartId = getCartSessionId(ctx);
                if (currentCartId) {
                    const newCartId = await createCartSession(apolloConfig, ctx);
                    setCartSessionId(newCartId, ctx);
                    console.info('Previous cart is inactive. New cart created:', newCartId);
                }
            }
        }
        return {
            success: false,
            isCartIdNotFound,
        };
    }
};
const mergeCarts = async (sourceCartId, destinationCartId, apolloConfig) => {
    try {
        await privateMutate(apolloConfig(), {
            mutation: MergeCarts,
            variables: {
                source_cart_id: sourceCartId,
                destination_cart_id: destinationCartId,
            },
        });
    }
    catch (e) {
        // Skip error to avoid crash of login
    }
};
const getProductOldPrice = (item, currencyCode, language, noZeroAfterDecimal, qty) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const price = item.prices.price.value;
    if (typeof price !== 'number')
        return '';
    let oldPrice = price;
    // Since we removed price_range from AddConfigurableProduct, we need to calculate the old price differently using price_gap
    if (item.product.type_id === ProductType.Configurable) {
        // First try to get price_range if available
        const priceRangeValue = (_d = (_c = (_b = (_a = item.configured_variant) === null || _a === void 0 ? void 0 : _a.price_range) === null || _b === void 0 ? void 0 : _b.minimum_price) === null || _c === void 0 ? void 0 : _c.regular_price) === null || _d === void 0 ? void 0 : _d.value;
        if (priceRangeValue) {
            oldPrice = priceRangeValue;
        }
        // If not available, use price_gap
        else if ((_f = (_e = item.configured_variant) === null || _e === void 0 ? void 0 : _e.price_gap) === null || _f === void 0 ? void 0 : _f.value) {
            oldPrice = price + item.configured_variant.price_gap.value;
        }
        // Fall back to product price_gap
        else if ((_g = item.product.price_gap) === null || _g === void 0 ? void 0 : _g.value) {
            oldPrice = price + item.product.price_gap.value;
        }
    }
    else {
        // For simple products
        const priceRangeValue = (_k = (_j = (_h = item.product.price_range) === null || _h === void 0 ? void 0 : _h.minimum_price) === null || _j === void 0 ? void 0 : _j.regular_price) === null || _k === void 0 ? void 0 : _k.value;
        if (priceRangeValue) {
            oldPrice = priceRangeValue;
        }
        // Fall back to price_gap if available
        else if ((_l = item.product.price_gap) === null || _l === void 0 ? void 0 : _l.value) {
            oldPrice = price + item.product.price_gap.value;
        }
    }
    // Only return non-zero values to avoid showing same price twice
    if (oldPrice === price)
        return '';
    return formatPrice(qty ? qty * oldPrice : oldPrice, currencyCode, language, noZeroAfterDecimal);
};
const getProductNewPrice = (item, currencyCode, language, noZeroAfterDecimal, qty) => {
    const price = item.prices.price.value;
    if (typeof price !== 'number')
        return '';
    return formatPrice(qty ? qty * price : price, currencyCode, language, noZeroAfterDecimal);
};
const getTotalPrice = (item, currencyCode, language, noZeroAfterDecimal) => {
    const price = item.prices.price.value;
    if (typeof price !== 'number')
        return '';
    return formatPrice(price * item.quantity, currencyCode, language, noZeroAfterDecimal);
};
const getCartItemStockInfo = (item, t) => {
    var _a, _b, _c, _d;
    const backorderStatus = ((_a = item === null || item === void 0 ? void 0 : item.configured_variant) === null || _a === void 0 ? void 0 : _a.backorder_status) || item.product.backorder_status;
    const stockStatus = ((_b = item === null || item === void 0 ? void 0 : item.configured_variant) === null || _b === void 0 ? void 0 : _b.stock_status) || item.product.stock_status;
    const stockQuantity = ((_c = item === null || item === void 0 ? void 0 : item.configured_variant) === null || _c === void 0 ? void 0 : _c.quantity) || item.product.quantity;
    const maxCartQuantity = ((_d = item === null || item === void 0 ? void 0 : item.configured_variant) === null || _d === void 0 ? void 0 : _d.max_qty_on_cart) || item.product.max_qty_on_cart;
    const cartQuantity = item.quantity;
    const stockInfo = {
        availableForSale: true,
        message: '',
        qty: stockQuantity,
    };
    if (!backorderStatus || !stockStatus) {
        stockInfo.availableForSale = false;
        stockInfo.message = t('$common.$validation.productNotAvailable');
        return stockInfo;
    }
    if (cartQuantity > maxCartQuantity) {
        stockInfo.availableForSale = false;
        stockInfo.qty = maxCartQuantity;
        stockInfo.message = t('$common.$validation.qtyAvailable', { number: maxCartQuantity });
        return stockInfo;
    }
    const isBackorderAllowedValue = isBackorderAllowed(backorderStatus);
    const isProductInStockValue = isProductInStock(stockStatus);
    if (isBackorderAllowedValue)
        return stockInfo;
    if (!isProductInStockValue) {
        stockInfo.availableForSale = false;
        stockInfo.message = t('$common.$labels.outStock');
        return stockInfo;
    }
    if (cartQuantity > stockQuantity) {
        stockInfo.availableForSale = false;
        stockInfo.qty = stockQuantity;
        if (!stockQuantity || stockQuantity === 0) {
            stockInfo.message = t('$common.$labels.outStock');
        }
        else {
            stockInfo.message = t('$common.$validation.qtyAvailable', { number: stockQuantity });
        }
        return stockInfo;
    }
    if (stockQuantity < 9) {
        stockInfo.message = t('$common.$validation.qtyLeft', { number: stockQuantity });
        return stockInfo;
    }
    return stockInfo;
};
const isAnyProductOutOfStock = (items) => items.findIndex(item => {
    var _a, _b, _c, _d;
    let backorderStatus;
    let stockStatus;
    let stockQuantity;
    let maxCartQuantity;
    const productType = item.product.type_id;
    if (productType === ProductType.Simple) {
        stockStatus = item.product.stock_status;
        backorderStatus = item.product.backorder_status;
        stockQuantity = item.product.quantity;
        maxCartQuantity = item.product.max_qty_on_cart;
    }
    else {
        stockStatus = (_a = item === null || item === void 0 ? void 0 : item.configured_variant) === null || _a === void 0 ? void 0 : _a.stock_status;
        backorderStatus = (_b = item === null || item === void 0 ? void 0 : item.configured_variant) === null || _b === void 0 ? void 0 : _b.backorder_status;
        stockQuantity = (_c = item === null || item === void 0 ? void 0 : item.configured_variant) === null || _c === void 0 ? void 0 : _c.quantity;
        maxCartQuantity = (_d = item === null || item === void 0 ? void 0 : item.configured_variant) === null || _d === void 0 ? void 0 : _d.max_qty_on_cart;
    }
    if (item.quantity > maxCartQuantity)
        return true;
    const isBackorderAllowedValue = isBackorderAllowed(backorderStatus);
    if (isBackorderAllowedValue)
        return false;
    const isProductInStockValue = isProductInStock(stockStatus);
    if (!isProductInStockValue)
        return true;
    return item.quantity > stockQuantity;
}) !== -1;
const getOrCreateCartSessionId = async (apolloConfig, consent, ctx) => {
    const cartSessionId = getCartSessionId(ctx);
    const reactivateCartSessionId = getReactivateCartSessionId(ctx);
    const cookieConsent = getCookie('CookieConsent', ctx);
    let options = { ...ctx };
    if (cookieConsent && (cookieConsent === null || cookieConsent === void 0 ? void 0 : cookieConsent.includes('preferences:true'))) {
        const oneMonthFromNow = new Date();
        oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1);
        options = { ...options, expires: oneMonthFromNow };
    }
    // If we have a reactivation cart session ID but no current cart session ID, try to reactivate
    if (reactivateCartSessionId && !cartSessionId) {
        const reactivateResult = await reactivateCart(reactivateCartSessionId, apolloConfig, ctx);
        if (reactivateResult.success) {
            // Return the newly reactivated cart session ID
            return getCartSessionId(ctx);
        }
        // If reactivation failed, continue with normal flow to create a new cart
    }
    if (cartSessionId)
        return cartSessionId;
    const newCartSessionId = await createCartSession(apolloConfig);
    setCartSessionId(newCartSessionId, options);
    return newCartSessionId;
};
const assignCartFromGuestToLogged = async (apolloConfig) => {
    const guestCartSessionId = getCartSessionId();
    const loggedCartSessionId = await createCartSession(apolloConfig);
    if (guestCartSessionId) {
        await mergeCarts(guestCartSessionId, loggedCartSessionId, apolloConfig);
    }
    setCartSessionId(loggedCartSessionId);
};
const isCartSessionValid = (errorMsg) => CART_INVALID_ERROR_MESSAGES.findIndex((error) => errorMsg.includes(error)) === -1;
const checkCartSessionIdValidity = (errorMsg, ctx) => {
    if (isCartSessionValid(errorMsg))
        return;
    deleteCartSessionId(ctx);
    deleteCartGtmData();
};
const getProductImage = (item) => {
    let url = '';
    let label = '';
    if (item.product.type_id === ProductType.Configurable && item.configured_variant) {
        url = get(item, 'configured_variant.thumbnail.url', '');
        label = get(item, 'configured_variant.thumbnail.label', '');
    }
    else {
        url = item.product.thumbnail.url;
        label = item.product.thumbnail.label;
    }
    return { url, label };
};

export { assignCartFromGuestToLogged, checkCartSessionIdValidity, createCartSession, deleteCartGtmData, deleteCartSessionId, getCartItemStockInfo, getCartSessionId, getOrCreateCartSessionId, getProductImage, getProductNewPrice, getProductOldPrice, getReactivateCartSessionId, getTotalPrice, isAnyProductOutOfStock, isCartSessionValid, reactivateCart, setCartSessionId };
//# sourceMappingURL=cart.js.map
